import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  settings: 'Settings',
  lockAccounting: 'LockAccounting',
  inboundTickets: 'InboundTickets',
  outboundTickets: 'OutboundTickets',
  bills: 'Bills',
  payments: 'Payments',
  invoices: 'Invoices',
  invoicePayments: 'InvoicePayments',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.lockAccounting],
  endpoints: {
    getLockAccountingPeriod: {
      providesTags: () => [{ type: TAG_TYPES.lockAccounting }],
    },
    updateLockAccountingPeriod: {
      invalidatesTags: () => [{ type: TAG_TYPES.lockAccounting }, { type: TAG_TYPES.settings }],
    },
    getLockedEntities: {
      providesTags: () => [
        { type: TAG_TYPES.inboundTickets },
        { type: TAG_TYPES.outboundTickets },
        { type: TAG_TYPES.bills },
        { type: TAG_TYPES.payments },
        { type: TAG_TYPES.invoices },
        { type: TAG_TYPES.invoicePayments },
      ],
    },
  },
})

export const useGetLockedEntitiesLazyQuery = api.endpoints.getLockedEntities.useLazyQuery

export const { useGetLockAccountingPeriodQuery, useUpdateLockAccountingPeriodMutation, useGetLockedEntitiesQuery } = api
